import React, { useContext, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useToast } from '../context/ToastContext';
import logo from '../assets/logo.png';
import { UserRoleContext } from '../context/UserRoleContext';
import { EventContext } from '../context/EventContext';
import { getEventByCode } from '../services/eventService';
import { Event } from '../types/Event';
import { getRegistrantsByEmailLastNameEventIdForCheckin, sendSelfCheckinRegistrant } from '../services/registrantService';
import { EnrichedRegistrant } from '../types/Registrant'; // Assuming Registrant type exists
import { ROUTES } from '../constants/routes';

const CheckInComponent: React.FC = () => {
  const navigate = useNavigate();
  const { addToast } = useToast();
  const { userRole } = useContext(UserRoleContext);
  const { event_code } = useParams<{ event_code: string }>();
  const [event, setEvent] = useState<Event | null>(null);
  const [lastName, setLastName] = useState<string>('');
  const [email, setEmail] = useState<string>('');
  const [registrants, setRegistrants] = useState<EnrichedRegistrant[]>([]); // For storing registrants data

  const { currentEvent } = useContext(EventContext); // Event context

  useEffect(() => {
    const fetchEvent = async () => {
      if (event_code) {
        const ev = await getEventByCode(event_code);
        if (ev && ev.checkin_open) {
          setEvent(ev);
        } else {
          if (!ev) {
            addToast('Invalid event code, redirecting to home page.', true);
          } else {
            addToast('Event is closed, please check back later', true);
          }
          navigate(ROUTES.HOME);
        }
      } else {
        addToast('No event code, redirecting to home page.', true);
        navigate(ROUTES.HOME);
      }
    };

    fetchEvent();
  }, [event_code]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (email && lastName && event?.event_id) {
      try {
        const registrantsData = await getRegistrantsByEmailLastNameEventIdForCheckin(email, lastName, event.event_id);
        setRegistrants(registrantsData);
      } catch (error) {
        addToast('Failed to fetch registrant.', true);
      }
    } else {
      addToast('Please fill in all fields before submitting.', true);
    }
  };

  const handleCheckIn = async (registrantId: string) => {
    // Perform check-in logic here
    if (event) {
      const success = await sendSelfCheckinRegistrant(registrantId, event?.event_id);
      if (success) {
        addToast(`You have been successfully checked-in. Please enjoy ${event.event_name}!`);
        navigate(`${ROUTES.CHECKIN_SUCCESS}/${event.event_code}`);
      } else {
        addToast(`SERVER ERROR`, true);
      }
    } else {
      addToast('No event, unable to check in registrant', true);
    }
  };

  return (
    <div style={{ alignContent: 'center', justifyContent: 'center', display: 'flex', width: '100%'}}>
      <div className="card" style={{ maxWidth: '650px', backgroundColor: 'white', justifyContent: 'center', alignItems: 'center', textAlign: 'center', maxHeight: '100%', marginTop: '60px' }}>
        <img src={logo} alt="Cyne Up" style={{ maxWidth: '50%', margin: 'none' }} />
        <h1 style={{ marginTop: '0px' }}>Check-In</h1>
        <h2 style={{ margin: '0px' }}>{event?.event_name}</h2>
        <form onSubmit={handleSubmit} style={{ boxShadow: 'none' }}>
          <div className="form-group">
            <label htmlFor="email"><strong>Registrant Email</strong><span style={{ color: 'red' }}> *</span></label>
            <input
              type="email"
              id="email"
              name="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter registrant's email"
              maxLength={100}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="lastName"><strong>Last Name</strong><span style={{ color: 'red' }}> *</span></label>
            <input
              type="text"
              id="lastName"
              name="lastName"
              value={lastName}
              onChange={(e) => setLastName(e.target.value)}
              placeholder="Smith"
              maxLength={50}
              required
            />
          </div>
          <button type="submit" style={{ marginTop: '20px' }}>Search Registrants</button>
        </form>

        {/* Display registrants in a table after form submission */}
        {registrants.length > 0 && (
          <div>
            <h3 style={{marginTop: '0px'}}>Registrants</h3>
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead>
                <tr>
                  <th>First Name</th>
                  <th>Last Name</th>
                  <th>Organization</th>
                  <th>Check-In</th>
                </tr>
              </thead>
              <tbody>
                {registrants.map((registrant) => (
                  <tr key={registrant.registrant_id}>
                    <td>{registrant.first_name}</td>
                    <td>{registrant.last_name}</td>
                    <td>{registrant.organization_name}</td>
                    <td>
                      {(registrant.is_checked_in == true) && <button className="cancelButton" onClick={() => addToast(`You have already been checked-in. Enjoy the event!`)}>Checked-In</button>}
                      {(registrant.is_checked_in == false) && <button onClick={() => handleCheckIn(registrant.registrant_id)}>Check-In</button>}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        {userRole && (
          <div className="buttonsRow">
            <div className='buttonsLeft'>
            </div>
            <button onClick={() => navigate('/home')} className="cancelButton">Return To Home</button>
          </div>
        )}
      </div>
    </div>
  );
};

export default CheckInComponent;
